import i18next from "i18next";
import translationDe from "../Translations/translations_DE";

i18next.init({
    interpolation: {
        // React already does escaping
        escapeValue: false,
    },
    lng: "de",
    resources: {
        de: {
            translation: translationDe,
        },
    },
});

export default i18next;
